/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type CustomFieldsDirectoryAdminType from '@jira/spa-apps__admin-pages-custom-fields-directory/src/CustomFieldsDirectoryAdminType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyCustomFieldsDirectoryAdmin: LazyComponent<
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: Record<any, any>) => React.JSX.Element
> = lazyForPaint<typeof CustomFieldsDirectoryAdminType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-custom-fields-directory", jiraSpaEntry: "async-admin-pages-custom-fields-directory" */ '@jira/spa-apps__admin-pages-custom-fields-directory/src/CustomFieldsDirectoryAdminType.tsx'
		),
	),
);

const AsyncCustomFieldsDirectoryAdmin = (): React.JSX.Element => (
	<LazyPage
		Page={LazyCustomFieldsDirectoryAdmin}
		pageId="admin-pages-custom-fields-directory"
		shouldShowSpinner
	/>
);

export default AsyncCustomFieldsDirectoryAdmin;
